import { TaoUser } from "@/types/tao-routing";
import { tokenAxios } from "@/utils/axios";
import { useAppState } from "@/contexts/app-state";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildApiUrl } from "@/utils/api";

interface UpdateUserArgs {
    body: TaoUser;
    practiceId: string;
    requestedUser: string;
}

const postUpdateUser = async ({ body, practiceId, requestedUser }: UpdateUserArgs) => {
    await tokenAxios().post(buildApiUrl("updateUserPermissions"),
        body,
     {
        params: {
            practiceId,
            requestedUser
        }
    });
};

export const useUpdateUser = () => {
    const { context, loggedInUser } = useAppState();
    const queryClient = useQueryClient();
    const practiceId = context?.athena?.practiceId ?? "8967";
    const { isPending, isError, isSuccess, mutate } = useMutation({
        mutationFn: postUpdateUser,
        onSettled: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["Tao-Routing-Users"],
          });
          await queryClient.invalidateQueries({
            queryKey: ["users"],
          });
        },
      });

const updateUser = (body: TaoUser) =>
        mutate({
            body: body,
            practiceId: practiceId,
            requestedUser: loggedInUser,
        });

        return {
            isPending,
            isError,
            isSuccess,
            updateUser,
          };
};
